// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Video-module--bx--text-truncate--end--1fp3O";
export var bxTextTruncateFront = "Video-module--bx--text-truncate--front--1zlw-";
export var skeleton = "Video-module--skeleton--3Bj1F";
export var video = "Video-module--video--1N3rj";
export var videoButton = "Video-module--video-button--kg9h-";
export var videoContainer = "Video-module--video-container--1T_oM";
export var videoIsPlaying = "Video-module--video--is-playing--2hG5f";
export var vimeo = "Video-module--vimeo--1YDWG";